import { Outlet } from 'react-router-dom';
import { TopBarV3 as TopBar } from './TopBarV3.jsx';

export function Layout() {
  return (
    <>
      <TopBar />
      <Outlet />
    </>
  );
}
